import { AfterViewInit, Component, ContentChildren, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ToolbarItemDirective } from '../directives/toolbar-item.directive';
import { ToolbarFilterPipe } from '../pipes/toolbar-filter.pipe';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToolbarButtonFilterPipe } from '../pipes/toolbar-button-filter.pipe';
import { CecBreakpointPipe } from '../../pipes/cec-breakpoint.pipe';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'cec-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule, ToolbarFilterPipe, CommonModule, MatTooltipModule, ToolbarButtonFilterPipe, CecBreakpointPipe, MatMenuModule],
  host: {
    style: 'width: fit-content',
  },
})
export class ToolbarComponent {

  @Output()
  public onButtonClicked = new EventEmitter<string>();

  /** Defines toolbar items in HTML */
  @ContentChildren(ToolbarItemDirective)
  public items: ToolbarItemDirective[] = [];

  public onClickButton(id: string): void {
    this.onButtonClicked.emit(id);
  }
}
